.breadcrumb {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: 0.4rem;
  user-select: none;

  & svg {
    height: 1.2rem;
    fill: var(--color-grey-5);
  }
}

.crumb {
  font-size: 1.3rem;
  font-weight: 500;
  color: #e3e4e7;

  &:last-child {
    color: var(--white-default);
    cursor: default;
  }

  &:hover {
    cursor: pointer;
    color: white;
  }
}
